export const enumKeys = <E extends Record<string, unknown>>(e: E): (keyof E)[] => {
  return Object.keys(e) as (keyof E)[]
}
